/**
 * Hook to auto-dismiss a flash after 8s of no user interaction. If the user
 * mouses over, the timer will pause and then be reset to 8s after mouse-off.
 */

export const Flash = {
  mounted() {
    const timeout = parseInt(this.el.dataset.timeout, 10);
    if (timeout) {
      const hide = () =>
        liveSocket.execJS(this.el, this.el.getAttribute("phx-click"));
      this.timer = setTimeout(() => hide(), timeout);

      this.el.addEventListener("phx:hide-start", () =>
        clearTimeout(this.timer),
      );
      this.el.addEventListener("mouseover", () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => hide(), 8000);
      });
    }
  },

  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};

export default Flash;
